import hasTrainingSystemAccess from '@/pure/trainingSystemAccess';
import router from '@/router';
import { IJoinedProblem } from '@/types';
import fetchJoinedProblems from '@/vuex/actions/fetchJoinedProblems';

export default {
  // delete cards from decks
  async deleteCards({ commit, getters }: any, problemIds: number[]) {
    await getters.apiDelete('/trainingSystem/cards', { data: problemIds });
    problemIds.forEach((pid) => {
      commit('deleteOneJoinedProblem', pid);
    });
  },

  // --
  fetchJoinedProblems,

  // Get just one, include sgf
  async fetchOneJoinedProblem({ state, commit, getters }: any, pb_id: number): Promise<void> {
    if (state.joinedProblems.length > 1) return;
    const url = `trainingSystem/problems?include=${pb_id}`;
    try {
      const response = await getters.apiGet(url);
      commit('loadJoinedProblems', response.data);
    } catch (e) {
      const err = e as Error;
      console.log(err);
      commit('pushFlash', {
        title: 'There was an error while fetching a single Training System problem:',
        message: err.message,
        variant: 'warning',
      });
    }
  },

  // get sgf, add to joinedProblems record
  async fetchAndSaveOneSgf({ state, commit, getters }: any, problemId: number) {
    const hasAccess = hasTrainingSystemAccess(
      getters.isLoggedIn,
      state.user,
      state.membership,
      new Date(),
    );
    if (!hasAccess) return;
    try {
      const response = await getters.apiGet(`fetch/sgfs?ids=${problemId}`);
      const index = state.joinedProblems.findIndex(
        (jp: IJoinedProblem) => jp.problemId === problemId,
      );
      const { sgf } = response.data[0];
      commit('changeExistingStateValue', {
        table: 'joinedProblems',
        change: { sgf },
        index,
      });
    } catch (e) {
      const err = e as Error;
      commit('pushFlash', {
        title: 'Error fetching sgf file',
        message: `${err.message} -- returning to Home page`,
        variant: 'danger',
      });
      router.push('/');
    }
  },

  async moveCardsToNewDeck(
    { commit, getters }: any,
    { problemIds, newDeckId }: { problemIds: number[]; newDeckId: number },
  ) {
    try {
      await getters.apiPut('/trainingSystem/move-cards', {
        data: {
          problemIds,
          destinationDeckId: newDeckId,
        },
      });
      commit('changeJpsDeckIds', { problemIds, newDeckId });
    } catch (e) {
      const err = e as Error;
      commit('pushFlash', {
        title: 'Error at server',
        message: `${err.message} -- couldn't move cards to new deck`,
        variant: 'danger',
      });
    }
  },

  async renameProblems(
    { getters, commit }: any,
    changes: { problemId: number; newFilename: string }[],
  ) {
    await getters.apiPut('/trainingSystem/rename-problems', { data: changes });
    changes.forEach((change) => commit('changeJpFilename', change));
  },
};
